import { CalendarCheck } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/lib/siteData";

export const Faq = () => {
  return (
    <section id="faq" className="relative bg-gradient-subtle py-20 lg:py-28">
      <div className="mx-auto max-w-4xl px-5 lg:px-8">
        <Reveal className="text-center">
          <span className="mb-4 inline-block rounded-full bg-accent px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wider text-accent-foreground">
            FAQ
          </span>
          <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl lg:text-5xl">
            Questions? We’ve got answers.
          </h2>
          <p className="mt-5 text-base text-muted-foreground md:text-lg">
            Everything you need to know about taking control of your website.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="overflow-hidden rounded-2xl border border-border bg-card px-5 shadow-sm data-[state=open]:border-techblue/40 data-[state=open]:shadow-card"
              >
                <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-navy hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-muted-foreground">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.15} className="mt-10 text-center">
          <p className="text-sm text-muted-foreground">Still have questions?</p>
          <Button asChild variant="navy" size="lg" className="mt-3">
            <a href="#demo">
              <CalendarCheck className="h-4 w-4" /> Schedule a Demo
            </a>
          </Button>
        </Reveal>
      </div>
    </section>
  );
};
